// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2NV1Z","notes":"Notes_notes__3x93i","note":"Notes_note__188Dx","markdown":"Notes_markdown__1okl7"};